const messages = {
  pt: {
    translations: {
      common: {
        cancel: 'Cancelar',
        add: 'Adicionar',
        back: 'Voltar',
        cancelAria: 'Cancelar operação',
        addAria: 'Adicionar item',
        loading: 'Carregando...',
      },
      selectLanguage: 'Selecione um idioma',
      signup: {
        title: 'Cadastre-se',
        toasts: {
          success: 'Usuário criado com sucesso! Faça seu login!!!.',
          fail: 'Erro ao criar usuário. Verifique os dados informados.',
        },
        form: {
          name: 'Nome da empresa',
          email: 'Email',
          phone: 'Telefone com (DDD)',
          plan: 'Plano',
          password: 'Senha',
        },
        formErrors: {
          name: {
            required: 'Nome da empresa é obrigatório',
            short: 'Nome muito curto',
            long: 'Nome muito longo',
          },
          password: {
            short: 'Senha muito curta',
            long: 'Senha muito longa',
          },
          email: {
            required: 'Email é obrigatório',
            invalid: 'Email inválido',
          },
        },
        buttons: {
          submit: 'Cadastrar',
          login: 'Já tem uma conta? Entre!',
        },
        plan: {
          attendant: 'Atendente',
          whatsapp: 'WhatsApp',
          queues: 'Pipelines',
        },
      },
      login: {
        title: 'Login',
        form: {
          email: 'Email',
          password: 'Senha',
        },
        buttons: {
          submit: 'Entrar',
          register: 'Registre-se, agora mesmo!',
        },
      },
      resetPassword: {
        title: 'Redefinir Senha',
        toasts: {
          emailSent: 'Email enviado com sucesso!',
          emailNotFound: 'Email não encontrado!',
          passwordUpdated: 'Senha atualizada com sucesso!',
        },
        formErrors: {
          email: {
            required: 'Email é obrigatório',
            invalid: 'Email inválido',
          },
          newPassword: {
            required: 'Nova senha é obrigatória',
            matches:
              'Sua senha precisa ter no mínimo 8 caracteres, sendo uma letra maiúscula, uma minúscula e um número.',
          },
          confirmPassword: {
            required: 'Confirmação de senha é obrigatória',
            matches: 'As senhas não correspondem',
          },
        },
        form: {
          email: 'Email',
          verificationCode: 'Código de verificação',
          newPassword: 'Nova senha',
          confirmPassword: 'Confirme a nova senha',
        },
        buttons: {
          submitEmail: 'Enviar email',
          submitPassword: 'Redefinir senha',
          back: 'Não tem uma conta? Cadastre-se!',
        },
      },
      dashboard: {
        toasts: {
          selectFilterError: 'Parametrize o filtro',
          userChartError: 'Erro ao obter informações da conversa',
          dateChartError: 'Erro ao obter informações da conversa',
        },
        filters: {
          initialDate: 'Data Inicial',
          finalDate: 'Data Final',
          filterType: {
            title: 'Tipo de Filtro',
            options: {
              perDate: 'Filtro por Data',
              perPeriod: 'Filtro por Período',
            },
            helper: 'Selecione o tipo de filtro desejado',
          },
        },
        periodSelect: {
          title: 'Período',
          options: {
            none: 'Nenhum selecionado',
            last3: 'Últimos 3 dias',
            last7: 'Últimos 7 dias',
            last15: 'Últimos 15 dias',
            last30: 'Últimos 30 dias',
            last60: 'Últimos 60 dias',
            last90: 'Últimos 90 dias',
          },
          helper: 'Selecione o período desejado',
        },
        counters: {
          inTalk: 'Em conversa',
          waiting: 'Aguardando',
          finished: 'Finalizados',
          newContacts: 'Novos contatos',
          averageTalkTime: 'T.M. de Conversa',
          averageWaitTime: 'T.M. de Espera',
          averageResponseTime: 'T.M. de Resposta',
          completedTickets: 'Tickets Concluídos',
        },
        buttons: {
          filter: 'Filtrar',
        },
        onlineTable: {
          ratingLabel: '1 - Insatisfeito, 2 - Satisfeito, 3 - Muito Satisfeito',
          name: 'Nome',
          ratings: 'Avaliações',
          avgSupportTime: 'T.M. de Atendimento',
          status: 'Status (Atual)',
        },
        charts: {
          user: {
            label: 'Gráfico de Conversas',
            title: 'Total de Conversas por Usuários',
            start: 'Início',
            end: 'Fim',
            filter: 'Filtrar',
          },
          message: 'Mensagens',
          date: {
            label: 'Gráfico de Conversas',
            title: 'Total',
            start: 'Início',
            end: 'Fim',
            filter: 'Filtrar',
          },
        },
        idleStatus: {
          title: 'Status de Ociosidade dos Tickets',
          total: 'Total de Tickets',
          normal: 'Normal (Verde)',
          warning: 'Atenção (Amarelo)',
          critical: 'Crítico (Vermelho)',
        },
      },
      metrics: {
        title: 'Dashboard de métricas',
        subtitle: 'Acompanhe o desempenho e performance do seu CRM',
        sections: {
          overview: 'Visão Geral',
          charts: 'Gráficos e Análises',
          performance: 'Performance e Rankings',
          goals: 'Gerenciamento de Metas',
        },
        filters: {
          startDate: 'Data Inicial',
          endDate: 'Data Final',
          user: 'Usuário',
          queue: 'Pipeline',
          tag: 'Tag',
          pipelineStage: 'Etapa da Pipeline',
          allUsers: 'Todos os Usuários',
          allQueues: 'Todas as Pipelines',
          allTags: 'Todas as Tags',
          allStages: 'Todas as Etapas',
          apply: 'Aplicar Filtros',
          refresh: 'Atualizar',
          clear: 'Limpar Filtros',
          adminAccess: 'Acesso Administrativo',
          userAccess: 'Acesso de Usuário',
          allUsersData: 'Dados de Todos os Usuários',
          ownData: 'Apenas Seus Dados',
        },
        cards: {
          conversions: 'Conversões',
          totalValue: 'Valor Total',
          conversionRate: 'Taxa de Conversão',
          avgConversionTime: 'Tempo Médio de Conversão',
          totalLeads: 'Total de Leads',
          newLeads: 'Novos Leads',
          qualifiedLeads: 'Leads Qualificados',
          totalMessages: 'Total de Mensagens',
          activeTickets: 'Tickets Ativos',
          pendingTickets: 'Tickets Pendentes',
          onlineUsers: 'Usuários Online',
          avgResponseTime: 'Tempo Médio de Resposta',
        },
        goalProgress: 'Progresso da Meta',
        loading: 'Carregando métricas...',
        progress: {
          progress: 'Progresso',
          goal: 'Meta',
        },
        charts: {
          message: 'Mensagem',
          messages: 'Mensagens',
          hourlyDistribution: 'Distribuição Horária de Mensagens',
          leadsDistribution: 'Distribuição de Leads',
          userPerformance: 'Performance por Usuário',
          queuePerformance: 'Performance por Pipeline',
          sentMessages: 'Mensagens Enviadas',
          receivedMessages: 'Mensagens Recebidas',
          tickets: 'Tickets',
          conversions: 'Conversões',
          newLeads: 'Novos Leads',
          qualifiedLeads: 'Leads Qualificados',
          convertedLeads: 'Leads Convertidos',
        },
        tables: {
          userPerformance: 'Performance por Usuário',
          queuePerformance: 'Performance por Pipeline',
          conversionRanking: 'Ranking de Conversões',
          user: 'Usuário',
          queue: 'Pipeline',
          tickets: 'Tickets',
          conversions: 'Conversões',
          conversionRate: 'Taxa de Conversão',
          rank: 'Ranking',
          totalValue: 'Valor Total',
          averageValue: 'Valor Médio',
          change: 'Variação',
          rowsPerPage: 'Linhas por página',
        },
        goals: {
          title: 'Metas de Usuários',
          add: 'Adicionar Meta',
          create: 'Criar Meta',
          edit: 'Editar Meta',
          update: 'Atualizar Meta',
          cancel: 'Cancelar',
          user: 'Usuário',
          metric: 'Métrica',
          target: 'Meta',
          period: 'Período',
          status: 'Status',
          actions: 'Ações',
          description: 'Descrição',
          active: 'Ativa',
          inactive: 'Inativa',
          confirmDelete: 'Tem certeza que deseja excluir esta meta?',
          metrics: {
            conversion: 'Conversões',
            financial: 'Valor Financeiro',
            leads: 'Leads',
            messages: 'Mensagens',
          },
          periods: {
            daily: 'Diário',
            weekly: 'Semanal',
            monthly: 'Mensal',
            yearly: 'Anual',
          },
        },
        errors: {
          fetchError: 'Erro ao buscar métricas',
          fetchRealtimeError: 'Erro ao buscar métricas em tempo real',
          fetchGoalsError: 'Erro ao buscar metas',
          createGoalError: 'Erro ao criar meta',
          updateGoalError: 'Erro ao atualizar meta',
          deleteGoalError: 'Erro ao deletar meta',
        },
        success: {
          goalCreated: 'Meta criada com sucesso',
          goalUpdated: 'Meta atualizada com sucesso',
          goalDeleted: 'Meta deletada com sucesso',
        },
      },
      plans: {
        toasts: {
          errorList: 'Não foi possível carregar a lista de registros',
          errorOperation: 'Não foi possível realizar a operação',
          error:
            'Não foi possível realizar a operação. Verifique se já existe uma plano com o mesmo nome ou se os campos foram preenchidos corretamente',
          success: 'Operação realizada com sucesso!',
        },
        confirm: {
          title: 'Exclusão de Registro',
          message: 'Deseja realmente excluir o registro?',
        },
        form: {
          name: 'Nome',
          users: 'Usuários',
          connections: 'Conexões',
          queues: 'Pipelines',
          value: 'Valor',
          internalChat: 'Chat Interno',
          externalApi: 'API Externa',
          kanban: 'Kanban',
          integrations: 'Integrações',
          campaigns: 'Campanhas',
          schedules: 'Agendamentos',
          enabled: 'Habilitadas',
          disabled: 'Desabilitadas',
          clear: 'Cancelar',
          delete: 'Excluir',
          save: 'Salvar',
          yes: 'Sim',
          no: 'Não',
          money: 'R$',
        },
      },
      kanban: {
        toasts: {
          removed: 'Ticket Tag Removido!',
          added: 'Ticket Tag Adicionado com Sucesso!',
        },
        open: 'Em aberto',
        seeTicket: 'Ver Ticket',
      },
      invoices: {
        title: 'Faturas',
        paid: 'Pago',
        open: 'Em Aberto',
        expired: 'Vencido',
        details: 'Detalhes',
        value: 'Valor',
        dueDate: 'Data Venc.',
        status: 'Status',
        action: 'Ação',
        PAY: 'PAGAR',
        PAID: 'PAGO',
      },
      checkoutPage: {
        steps: {
          data: 'Dados',
          customize: 'Personalizar',
          review: 'Revisar',
        },
        success:
          'Assinatura realizada com sucesso!, aguardando a realização do pagamento',
        closeToEnd: 'Falta pouco!',
        BACK: 'VOLTAR',
        PAY: 'PAGAR',
        NEXT: 'PRÓXIMO',
        review: {
          title: 'Resumo da assinatura',
          details: 'Detalhes do plano',
          users: 'Usuários',
          whatsapp: 'Whatsapp',
          charges: 'Cobrança: Mensal',
          total: 'Total',
        },
        form: {
          firstName: {
            label: 'Nome completo*',
            required: 'Nome completo é obrigatório',
          },
          lastName: {
            label: 'Sobrenome*',
            required: 'Sobrenome é obrigatório',
          },
          address1: {
            label: 'Endereço*',
            required: 'Endereço é obrigatório',
          },
          city: {
            label: 'Cidade*',
            required: 'Cidade é obrigatório',
          },
          state: {
            label: 'Estado*',
            required: 'Estado é obrigatório',
          },
          zipcode: {
            label: 'CEP*',
            required: 'CEP é obrigatório',
            invalid: 'Formato de CEP inválido',
          },
          country: {
            label: 'País*',
            required: 'País é obrigatório',
          },
          useAddressForPaymentDetails: {
            label: 'Use este endereço para os detalhes de pagamento',
          },
          invoiceId: {
            label: 'Use este invoiceId',
          },
          nameOnCard: {
            label: 'Nome no cartão*',
            required: 'Nome no cartão é obrigatório',
          },
          cardNumber: {
            label: 'Número do cartão*',
            required: 'Número do cartão é obrigatório',
            invalid: 'Número do cartão inválido (ex: 4111111111111)',
          },
          expiryDate: {
            label: 'Data de validade*',
            required: 'Data de validade é obrigatória',
            invalid: 'Data de validade inválida',
          },
          cvv: {
            label: 'CVV*',
            required: 'CVV é obrigatório',
            invalid: 'CVV inválido (ex: 123)',
          },
        },
        pricing: {
          users: 'Usuários',
          connection: 'Conexão',
          queues: 'Pipelines',
          SELECT: 'SELECIONAR',
          month: 'mês',
        },
      },
      companies: {
        title: 'Cadastrar Empresa',
        form: {
          name: 'Nome da Empresa',
          plan: 'Plano',
          token: 'Token',
          submit: 'Cadastrar',
          success: 'Empresa criada com sucesso!',
        },
      },
      auth: {
        toasts: {
          success: 'Login efetuado com sucesso!',
        },
        token: 'Token',
      },
      connections: {
        title: 'Conexões',
        toasts: {
          deleted: 'Conexão com o WhatsApp excluída com sucesso!',
        },
        confirmationModal: {
          deleteTitle: 'Deletar',
          deleteMessage: 'Você tem certeza? Essa ação não pode ser revertida.',
          disconnectTitle: 'Desconectar',
          disconnectMessage:
            'Tem certeza? Você precisará ler o QR Code novamente.',
        },
        buttons: {
          add: 'Adicionar WhatsApp',
          disconnect: 'desconectar',
          tryAgain: 'Tentar novamente',
          qrcode: 'QR CODE',
          newQr: 'Novo QR CODE',
          connecting: 'Conectando',
        },
        toolTips: {
          disconnected: {
            title: 'Falha ao iniciar sessão do WhatsApp',
            content:
              'Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code',
          },
          qrcode: {
            title: 'Esperando leitura do QR Code',
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: 'Conexão estabelecida!',
          },
          timeout: {
            title: 'A conexão com o celular foi perdida',
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: 'Nome',
          status: 'Status',
          lastUpdate: 'Última atualização',
          default: 'Padrão',
          actions: 'Ações',
          session: 'Sessão',
        },
      },
      whatsappModal: {
        title: {
          add: 'Adicionar WhatsApp',
          edit: 'Editar WhatsApp',
        },
        formErrors: {
          name: {
            required: 'Nome é obrigatório',
            short: 'Nome muito curto',
            long: 'Nome muito longo',
          },
        },
        tabs: {
          general: 'Geral',
          messages: 'Mensagens',
          assessments: 'Avaliações',
          integrations: 'Integrações',
          schedules: 'Horário de expediente',
        },
        form: {
          name: 'Nome',
          default: 'Padrão',
          sendIdQueue: 'Pipeline',
          noneOption: 'Nenhum',
          timeSendQueue: 'Redirecionar para pipeline em X minutos',
          queueRedirection: 'Redirecionamento de Pipeline',
          outOfHoursMessage: 'Mensagem de fora de expediente',
          queueRedirectionDesc:
            'Selecione uma pipeline para os contatos que não possuem pipeline serem redirecionados',
          prompt: 'Prompt',
          queue: 'Pipeline de Transferência',
          timeToTransfer: 'Transferir após x (minutos)',
          //maxUseBotQueues: "Enviar bot x vezes",
          //timeUseBotQueues: "Intervalo em minutos entre envio de bot",
          expiresTicket: 'Encerrar chats abertos após x minutos',
          expiresInactiveMessage: 'Mensagem de encerramento por inatividade',
          greetingMessage: 'Mensagem de saudação',
          complationMessage: 'Mensagem de conclusão',
          integration: 'Integrações',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        success: 'WhatsApp salvo com sucesso.',
      },
      qrCodeModal: {
        title: 'Utilize o seu WhatsApp:',
        steps: {
          one: '1 - Abra o WhatsApp no seu celular',
          two: {
            partOne: '2 - Toque em Mais opções no Android',
            partTwo: 'ou em Configurações',
            partThree: 'no iPhone',
          },
          three:
            '3 - Toque em Dispositivos conectados e, em seguida, em Conectar dispositivos',
          four: '4 - Aponte seu celular para essa tela para capturar o QR Code',
        },
        waiting: 'Aguardando leitura do QR Code',
      },
      qrCode: {
        message: 'Leia o QrCode para iniciar a sessão',
      },
      contacts: {
        title: 'Contatos',
        toasts: {
          deleted: 'Contato excluído com sucesso!',
          deletedAll: 'Todos contatos excluídos com sucesso!',
        },
        searchPlaceholder: 'Pesquisar...',
        confirmationModal: {
          deleteTitle: 'Deletar ',
          deleteAllTitle: 'Deletar Todos',
          importTitle: 'Importar contatos',
          deleteMessage:
            'Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.',
          deleteAllMessage:
            'Tem certeza que deseja deletar todos os contatos? Todos os tickets relacionados serão perdidos.',
          importMessage: 'Deseja importar todos os contatos do telefone?',
        },
        buttons: {
          import: 'Importar Contatos',
          add: 'Adicionar Contato',
          export: 'Exportar Contatos',
          delete: 'Excluir Todos Contatos',
        },
        table: {
          name: 'Nome',
          whatsapp: 'WhatsApp',
          email: 'Email',
          actions: 'Ações',
        },
      },
      contactImportModal: {
        title: 'Planílha de contatos',
        labels: {
          import: 'Importar contatos',
          result: 'resultados',
          added: 'Adicionados',
          savedContact: 'Contato salvo',
          errors: 'Erros',
        },
        buttons: {
          download: 'Baixar planílha modelo',
          import: 'Importar contatos',
        },
      },
      queueIntegrationModal: {
        title: {
          add: 'Adicionar projeto',
          edit: 'Editar projeto',
        },
        form: {
          id: 'ID',
          type: 'Tipo',
          name: 'Nome',
          projectName: 'Nome do Projeto',
          language: 'Linguagem',
          jsonContent: 'JsonContent',
          urlN8N: 'URL',
          typebotSlug: 'Typebot - Slug',
          typebotExpires: 'Tempo em minutos para expirar uma conversa',
          typebotKeywordFinish: 'Palavra para finalizar o ticket',
          typebotKeywordRestart: 'Palavra para reiniciar o fluxo',
          typebotRestartMessage: 'Mensagem ao reiniciar a conversa',
          typebotUnknownMessage: 'Mensagem de opção inválida',
          typebotDelayMessage: 'Intervalo (ms) entre mensagens',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
          test: 'Testar Bot',
        },
        messages: {
          testSuccess: 'Integração testada com sucesso!',
          addSuccess: 'Integração adicionada com sucesso.',
          editSuccess: 'Integração editada com sucesso.',
        },
      },
      sideMenu: {
        name: 'Menu Lateral Inicial',
        note: 'Se habilitado, o menu lateral irá iniciar fechado',
        options: {
          enabled: 'Aberto',
          disabled: 'Fechado',
        },
      },
      promptModal: {
        form: {
          name: 'Nome',
          prompt: 'Prompt',
          model: 'Modelo',
          max_tokens: 'Máximo de Tokens na resposta',
          temperature: 'Temperatura',
          apikey: 'API Key',
          max_messages: 'Máximo de mensagens no Histórico',
        },
        formErrors: {
          name: {
            short: 'Nome muito curto',
            long: 'Nome muito longo',
            required: 'Nome é obrigatório',
          },
          prompt: {
            short: 'Prompt muito curto',
            required: 'Descreva o treinamento para Inteligência Artificial',
          },
          modal: {
            required: 'Informe o modelo desejado para o Prompt',
          },
          maxTokens: {
            required: 'Informe o número máximo de tokens na resposta',
          },
          temperature: {
            required: 'Informe a temperatura',
          },
          apikey: {
            required: 'Informe a API Key',
          },
          queueId: {
            required: 'Informe a pipeline',
          },
          maxMessages: {
            required: 'Informe o número máximo de mensagens no histórico',
          },
        },
        success: 'Prompt salvo com sucesso!',
        setor: 'Informe o setor',
        title: {
          add: 'Adicionar Prompt',
          edit: 'Editar Prompt',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
      },
      prompts: {
        title: 'Prompts',
        table: {
          name: 'Nome',
          queue: 'Setor/Pipeline',
          max_tokens: 'Máximo Tokens Resposta',
          actions: 'Ações',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Você tem certeza? Essa ação não pode ser revertida!',
        },
        buttons: {
          add: 'Adicionar Prompt',
        },
      },
      contactModal: {
        title: {
          add: 'Adicionar contato',
          edit: 'Editar contato',
        },
        form: {
          mainInfo: 'Dados do contato',
          extraInfo: 'Informações adicionais',
          name: 'Nome',
          number: 'Número do Whatsapp',
          email: 'Email',
          extraName: 'Nome do campo',
          extraValue: 'Valor',
          whatsapp: 'Conexão Origem: ',
        },
        formErrors: {
          name: {
            required: 'Nome é obrigatório',
            short: 'Nome muito curto',
            long: 'Nome muito longo',
          },
          phone: {
            short: 'Número muito curto',
            long: 'Número muito longo',
          },
          email: {
            invalid: 'Email inválido',
          },
        },
        buttons: {
          addExtraInfo: 'Adicionar informação',
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        success: 'Contato salvo com sucesso.',
      },
      queueModal: {
        title: {
          add: 'Adicionar pipeline',
          edit: 'Editar pipeline',
        },
        form: {
          name: 'Nome',
          nameShort: 'Nome curto',
          nameLong: 'Nome longo',
          nameRequired: 'Nome é obrigatório',
          color: 'Cor',
          colorShort: 'Cor curta',
          colorLong: 'Cor longa',
          greetingMessage: 'Mensagem de saudação',
          complationMessage: 'Mensagem de conclusão',
          outOfHoursMessage: 'Mensagem de fora de expediente',
          ratingMessage: 'Mensagem de avaliação',
          token: 'Token',
          orderQueue: 'Ordem da pipeline (Bot)',
          integrationId: 'Integração',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        toasts: {
          success: 'Pipeline salva com sucesso.',
          info: 'Clique em salvar para registar as alterações',
        },
        tabs: {
          queueData: 'Dados da pipeline',
          attendanceTime: 'Horários de Atendimento',
        },
      },
      userModal: {
        title: {
          add: 'Adicionar usuário',
          edit: 'Editar usuário',
        },
        form: {
          name: 'Nome',
          email: 'Email',
          password: 'Senha',
          profile: 'Perfil',
          whatsapp: 'Conexão Padrão',

          allTicket: 'Ticket Sem Pipeline [Invisível]',
          allTicketEnabled: 'Habilitado',
          allTicketDesabled: 'Desabilitado',
        },
        formErrors: {
          name: {
            required: 'Nome é obrigatório',
            short: 'Nome muito curto',
            long: 'Nome muito longo',
          },
          password: {
            short: 'Senha muito curta',
            long: 'Senha muito longa',
          },
          email: {
            required: 'Email é obrigatório',
            invalid: 'Email inválido',
          },
        },
        labels: {
          liberations: 'Liberações',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        success: 'Usuário salvo com sucesso.',
      },
      scheduleModal: {
        title: {
          add: 'Novo Agendamento',
          addWithService: 'Novo Agendamento - {{service}}',
          edit: 'Editar Agendamento',
        },
        form: {
          body: 'Mensagem',
          contact: 'Contato',
          sendAt: 'Data de Agendamento',
          sentAt: 'Data de Envio',
          eventTitle: 'Título do Evento',
          eventDescription: 'Descrição do Evento',
          eventLocation: 'Localização',
          eventStartDateTime: 'Data/Hora de Início',
          eventEndDateTime: 'Data/Hora de Fim',
          doctorEmail: 'Email do Médico',
        },
        calendar: {
          title: 'Calendário do Médico',
          loading: 'Carregando...',
          noEvents: 'Nenhum evento encontrado para este médico',
          availableSlots: 'Horários disponíveis para {{date}}',
          dayEvents: 'Eventos do dia:',
          daysOfWeek: {
            sun: 'Dom',
            mon: 'Seg',
            tue: 'Ter',
            wed: 'Qua',
            thu: 'Qui',
            fri: 'Sex',
            sat: 'Sáb',
          },
          months: {
            january: 'Janeiro',
            february: 'Fevereiro',
            march: 'Março',
            april: 'Abril',
            may: 'Maio',
            june: 'Junho',
            july: 'Julho',
            august: 'Agosto',
            september: 'Setembro',
            october: 'Outubro',
            november: 'Novembro',
            december: 'Dezembro',
          },
          timeSlots: {
            title: 'Horários Disponíveis',
            busy: 'Ocupado',
            selected: 'Selecionado',
          },
          indicators: {
            hasEvents: 'Dias com eventos',
            today: 'Hoje',
            selected: 'Data selecionada',
            busy: 'Horário ocupado',
          },
        },
        buttons: {
          okAdd: 'Agendar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
          scheduleBusy: '⚠️ Horário Ocupado - Agendar Mesmo Assim',
          checkingAvailability: 'Verificando disponibilidade...',
        },
        success: 'Agendamento salvo com sucesso.',
        validation: {
          timeOccupied: '⚠️ Este horário está ocupado no calendário do médico',
          noDeal: 'Ticket não possui deals associados. Crie um deal primeiro.',
          noProducts: 'Nenhum deal possui produtos associados. Registre uma venda antes de agendar.',
          noProductEmail: 'Produto não possui email de médico configurado. Solicite a configuração do produto.',
          calendarNotFound: 'Calendário não encontrado para o email. Verifique a integração do Google Calendar.',
          registerSaleFirst: 'Registre uma venda antes de agendar.',
        },
      },
      tagModal: {
        title: {
          add: 'Nova Tag',
          edit: 'Editar Tag',
        },
        form: {
          name: 'Nome',
          color: 'Cor',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
        success: 'Tag salvo com sucesso.',
      },
      chat: {
        toasts: {
          fillTitle: 'Por favor, preencha o título da conversa.',
          fillUser: 'Por favor, selecione pelo menos um usuário.',
        },
        modal: {
          title: 'Conversa',
          titleField: 'Título',
        },
        confirm: {
          title: 'Excluir Conversa',
          message: 'Esta ação não pode ser revertida, confirmar?',
        },
        chats: 'Chats',
        messages: 'Mensagens',
        noTicketMessage: 'Selecione um ticket para começar a conversar.',
        buttons: {
          close: 'Fechar',
          save: 'Salvar',
          new: 'Nova',
          newChat: 'Novo',
        },
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: 'ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO',
          titleFileList: 'Lista de arquivo(s)',
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: 'Novo',
        },
      },
      ticketsQueueSelect: {
        placeholder: 'Pipelines',
      },
      tickets: {
        toasts: {
          deleted: 'O atendimento que você estava foi deletado.',
          unauthorized: 'Acesso não permitido',
        },
        attendanceCountLabel: 'Atendimentos concluídos/perdidos',
        attendanceCountClosedLabel: 'Atendimentos concluídos',
        attendanceCountLostLabel: 'Atendimentos perdidos',
        responseTime: {
          waitingLabel: 'Aguardando resposta',
          avgLabel: 'Tempo médio de resposta',
          errors: {
            loadMessages: 'Erro ao carregar mensagens',
          },
        },
        filters: {
          user: 'Filtro por usuários',
          tags: 'Filtro por tags',
          idleStatus: {
            title: 'Status de Ociosidade',
            all: 'Todos os Status',
            green: 'Normal (Verde)',
            yellow: 'Atenção (Amarelo)',
            red: 'Crítico (Vermelho)',
          },
        },
        notification: {
          message: 'Mensagem de',
        },
        tabs: {
          open: { title: 'Abertas' },
          closed: { title: 'Concluídos' },
          search: { title: 'Busca' },
        },
        search: {
          placeholder: 'Buscar atendimento e mensagens',
        },
        buttons: {
          showAll: 'Todos',
        },
      },
      transferTicketModal: {
        title: 'Transferir Ticket',
        fieldLabel: 'Digite para buscar usuários',
        fieldQueueLabel: 'Transferir para Pipeline',
        fieldQueuePlaceholder: 'Selecione uma pipeline',
        noOptions: 'Nenhum usuário encontrado com esse nome',
        buttons: {
          ok: 'Transferir',
          cancel: 'Cancelar',
        },
      },
      ticketsList: {
        pendingHeader: 'Aguardando',
        assignedHeader: 'Atendendo',
        noTicketsTitle: 'Nada aqui!',
        noTicketsMessage:
          'Nenhum atendimento encontrado com esse status ou termo pesquisado',
        buttons: {
          accept: 'Aceitar',
          closed: 'Finalizar',
          reopen: 'Reabrir',
          transfer: 'Transferir',
        },
      },
      ticketsListItem: {
        tooltip: {
          chatbot: 'Chatbot',
          peek: 'Espiar Conversa',
          connection: 'Conexão',
          user: 'Usuário',
          pipeline: 'Pipeline',
          stage: 'Estágio',
        },
        noQueue: 'SEM PIPELINE',
      },
      ticketAdvanced: {
        selectTicket: 'Selecionar Ticket',
        ticketNav: 'Ticket',
        attendanceNav: 'Atendimentos',
      },
      newTicketModal: {
        title: 'Criar Ticket',
        fieldLabel: 'Digite para pesquisar o contato',
        add: 'Adicionar',
        searchQueueError:
          'Ocorreu um erro inesperado ao tentar buscar as pipelines',
        selectQueue: 'Selecione uma pipeline',
        selectConection: 'Selecione uma conexão',
        buttons: {
          ok: 'Salvar',
          cancel: 'Cancelar',
        },
      },
      locationPreview: {
        button: 'Visualizar',
      },
      pipelines: {
        title: 'CRM',
        subtitle: 'Gerencie seus pipelines de vendas e processos',
        loading: 'Carregando pipelines...',
        createNew: 'Criar Nova Pipeline',
        createFirst: 'Criar Primeira Pipeline',
        access: 'Acessar',
        createdAt: 'Criado em',
        noDescription: 'Sem descrição',
        empty: {
          title: 'Nenhuma Pipeline Encontrada',
          description:
            'Você ainda não possui pipelines criadas. Crie sua primeira pipeline para começar.',
        },
        errors: {
          fetchError: 'Erro ao carregar pipelines',
          updateError: 'Erro ao atualizar pipeline',
          invalidId: 'ID da pipeline inválido',
          noOriginalData: 'Dados originais não encontrados',
          createStageError: 'Erro ao criar estágio',
          linkStageError: 'Erro ao vincular estágio à pipeline',
          nameRequired: 'Nome do estágio é obrigatório',
          invalidStageId: 'Estágio criado não possui ID válido',
          noPipelineSelected: 'Nenhuma pipeline selecionada para exclusão.',
          queueIdNotFound:
            'QueueId não encontrado. Não é possível excluir a pipeline.',
          deleteSuccess: 'Pipeline excluída com sucesso!',
          unknownError: 'Erro desconhecido ao excluir pipeline',
          deleteError: 'Erro ao excluir pipeline: {{error}}',
        },
        actions: {
          access: 'Acessar',
          configure: 'Configurar',
          edit: 'Editar',
          delete: {
            confirmation: 'Funcionalidade de exclusão será implementada',
          },
        },
        status: {
          active: 'Ativa',
          inactive: 'Inativa',
        },
        stats: {
          tickets: 'tickets',
          users: 'usuários',
        },
        menu: {
          view: 'Visualizar Pipeline',
          configure: 'Configurações',
          edit: 'Editar',
          stages: 'Estágios',
          delete: 'Excluir',
          pin: 'Fixar no topo',
          unpin: 'Desfixar',
        },
        pinned: {
          title: 'Fixados',
        },
        confirmation: {
          deleteTitle: 'Excluir Pipeline {{name}}?',
          deleteMessage:
            'Tem certeza que deseja excluir este pipeline? Esta ação não pode ser desfeita.',
        },
        specialNames: {
          noQueue: 'sem fila',
        },
        config: {
          title: 'Configurações do Pipeline',
          saved: 'Configurações salvas com sucesso!',
          basicInfo: 'Informações Básicas',
          name: 'Nome',
          description: 'Descrição',
          isActive: 'Ativo',
          settings: 'Configurações',
          autoAssign: 'Atribuição Automática',
          notifications: 'Notificações',
          showStats: 'Exibir Estatísticas',
          allowGuestView: 'Permitir Visualização de Convidados',
          stages: 'Estágios',
          greetingMessage: 'Mensagem de saudação',
          greetingMessageHelp:
            'Mensagem enviada ao transferir um lead para uma fila desta pipeline. Opcional; se vazio, usa a saudação da fila.',
          greetingMessagePlaceholder:
            'Ex.: Olá! Você foi direcionado ao setor de Vendas. Em breve será atendido(a).',
          saveGreeting: 'Salvar mensagem de saudação',
          addStage: 'Adicionar Estágio',
          stageName: 'Nome do Estágio',
          stageDescription: 'Descrição do Estágio',
          color: 'Cor',
          tagAdded: 'Estágio adicionado com sucesso!',
          stageLinked: 'Estágio vinculado à pipeline com sucesso!',
          tagDeleted: 'Estágio removido com sucesso!',
          stageMovedUp: 'Estágio movido para cima',
          stageMovedDown: 'Estágio movido para baixo',
          stageReordered: 'Estágio reordenado com sucesso',
          reorderStages: 'Reordenar Estágios',
          adminReorderMode: 'Modo Admin - Reordenação Ativa',
          moveUp: 'Mover para cima',
          moveDown: 'Mover para baixo',
          deleteStage: 'Excluir estágio',
          editStage: 'Editar estágio',
          removeUser: 'Remover usuário',
          moveUpAria: 'Mover estágio para cima',
          moveDownAria: 'Mover estágio para baixo',
          deleteStageAria: 'Excluir estágio',
          editStageAria: 'Editar estágio',
          addStageAria: 'Adicionar novo estágio',
          addUserAria: 'Adicionar usuário ao pipeline',
          removeUserAria: 'Remover usuário do pipeline',
          deletePipelineAria: 'Excluir pipeline permanentemente',
          saveAria: 'Salvar alterações do pipeline',
          stageNameAria: 'Nome do estágio',
          colorAria: 'Selecionar cor do estágio',
          colorPickerAria: 'Seletor de cor',
          selectUsersAria: 'Selecionar usuários para adicionar',
          users: 'Usuários',
          addUser: 'Adicionar Usuário',
          selectUsers: 'Selecione Usuários',
          selected: 'selecionado(s)',
          usersAdded: 'Usuário(s) adicionado(s) com sucesso!',
          userRemoved: 'Usuário removido com sucesso!',
          dangerZone: 'Zona de Perigo',
          deleteWarning:
            'Esta ação não pode ser desfeita. Todos os dados serão perdidos.',
          deletePipeline: 'Excluir Pipeline',
          confirmDelete: "Tem certeza que deseja excluir o pipeline '{name}'?",
          deleted: 'Pipeline excluído com sucesso!',
          save: 'Salvar Alterações',
          saving: 'Salvando...',
          creating: 'Criando...',
          noChanges: 'Nenhuma alteração foi feita',
          unsavedChanges:
            'Você tem alterações não salvas. Deseja sair mesmo assim?',
        },
        details: {
          title: 'Detalhes do Card',
          contactInfo: 'Informações de Contato',
          stageRequirements: 'Requisitos do Estágio',
          description: 'Descrição',
          noDescription: 'Nenhuma descrição disponível.',
          goToChat: 'Ir para Conversa',
          close: 'Fechar',
          noName: 'Nome não disponível',
          dealId: 'ID do Deal',
          totalValue: 'Valor Total',
          contactName: 'Nome do Contato',
          company: 'Empresa',
          phone: 'Telefone',
          email: 'Email',
          notAvailable: 'Não disponível',
          stageActivities: 'Atividades do Estágio',
          completed: 'Concluído',
          pending: 'Pendente',
          typeHere: 'Digite aqui...',
          updateActivityError: 'Erro ao atualizar atividade',
          noActivitiesConfigured:
            'Nenhuma atividade configurada para este estágio',
          activityHistory: {
            title: 'Histórico de Atividades',
            noActivities: 'Nenhuma atividade registrada ainda',
            loadingError: 'Erro ao carregar histórico de atividades',
            response: 'Resposta:',
            by: 'Por:',
            activityTypes: {
              requirementCompleted: 'Atividade {requirementName} foi concluída',
              requirementCreated:
                'Nova atividade {requirementName} foi adicionada',
              stageChanged: 'Deal movido de {fromStage} para {toStage}',
              stageMoved: 'Deal movido de {fromStageName} para {toStageName}',
              phoneCall: 'Ligação realizada com {contactName}',
              emailSent: 'Email enviado para {contactEmail}',
              messageSent: 'Mensagem enviada via WhatsApp',
              valueUpdated: 'Valor atualizado para R$ {newValue}',
              noteAdded: 'Nota adicionada: {note}',
              scheduleCreated: 'Agendamento criado para {scheduledDate}',
              default: 'Atividade registrada',
            },
            booleanValues: {
              true: 'Sim',
              false: 'Não',
            },
            stagePrefix: 'Estágio',
            client: 'cliente',
            sale: {
              completed: 'Venda realizada',
              productDetails: {
                quantity: 'Quantidade',
                value: 'Valor',
                total: 'Total',
              },
            },
          },
          requirements: {
            contactInitial: 'Contato inicial realizado',
            basicData: 'Dados básicos coletados',
            interestConfirmed: 'Interesse confirmado',
            needIdentified: 'Necessidade identificada',
            budgetDefined: 'Orçamento definido',
            decisionMaker: 'Decisor identificado',
            proposalSent: 'Proposta enviada',
            valueProposed: 'Valor proposto',
            deadlineDefined: 'Prazo definido',
            counterProposal: 'Contraposta recebida',
            termsDiscussed: 'Termos discutidos',
            objectionsTreated: 'Objeções tratadas',
            contractSigned: 'Contrato assinado',
            paymentConfirmed: 'Pagamento confirmado',
            deliveryCompleted: 'Entrega realizada',
          },
          cardMovedBack: 'Card movido de volta. Requisitos não cumpridos:',
          noStagesFound: 'Nenhum estágio encontrado nesta pipeline',
          noStagesDescription:
            'Esta pipeline ainda não possui estágios configurados.',
          noUsersFound: 'Nenhum usuário atribuído',
          noUsersDescription:
            'Adicione usuários para trabalhar nesta pipeline.',
          loadingPipeline: 'Carregando pipeline...',
        },
      },
      stageConfig: {
        title: 'Configuração do Estágio',
        newStage: 'Novo Estágio',
        basicInfo: 'Informações Básicas',
        name: 'Nome do Estágio',
        description: 'Descrição',
        color: 'Cor',
        selectColor: 'Selecionar cor',
        prerequisites: 'Pré-requisitos',
        prerequisitesDescription:
          'Selecione os pré-requisitos que devem ser cumpridos para que um ticket possa avançar para este estágio:',
        save: 'Salvar Alterações',
        create: 'Criar Estágio',
        saved: 'Estágio salvo com sucesso!',
        created: 'Estágio criado com sucesso!',
        activityTypes: {
          checkbox: 'Sim/Não (Checkbox)',
          select: 'Lista de Opções (Select)',
          text: 'Campo de Texto',
          date: 'Data',
          sale: 'Realizar venda',
          attach: 'Adicionar anexos',
          schedule: 'Agendamentos',
        },
        errors: {
          nameRequired: 'Nome do estágio é obrigatório',
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: 'Dashboard',
          metrics: 'Métricas',
          connections: 'Conexões',
          tickets: 'Atendimentos',
          quickMessages: 'Respostas Rápidas',
          tasks: 'Tarefas',
          contacts: 'Contatos',
          products: 'Produtos/Serviços',
          queues: 'Pipelines',
          tags: 'Tags',
          administration: 'Administração',
          users: 'Usuários',
          settings: 'Configurações',
          helps: 'Ajuda',
          messagesAPI: 'API',
          schedules: 'Disparos',
          campaigns: 'Campanhas',
          flows: 'Fluxos',
          annoucements: 'Informativos',
          chats: 'Chat Interno',
          financeiro: 'Financeiro',
          files: 'Lista de arquivos',
          prompts: 'Open.Ai',
          queueIntegration: 'Integrações',
        },
        appBar: {
          refresh: 'Recarregar página',
          notRegister: 'Sem notificações',
          greeting: {
            hello: 'Olá',
            welcome: 'Bem vindo a',
            active: 'Ativo até',
          },
          user: {
            profile: 'Perfil',
            logout: 'Sair',
          },
        },
      },
      queueIntegration: {
        title: 'Integrações',
        table: {
          id: 'ID',
          type: 'Tipo',
          name: 'Nome',
          projectName: 'Nome do Projeto',
          language: 'Linguagem',
          lastUpdate: 'Ultima atualização',
          actions: 'Ações',
        },
        buttons: {
          add: 'Adicionar Projeto',
        },
        searchPlaceholder: 'Pesquisar...',
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            'Você tem certeza? Essa ação não pode ser revertida! e será removida das pipelines e conexões vinculadas',
        },
      },
      files: {
        title: 'Lista de arquivos',
        table: {
          name: 'Nome',
          contacts: 'Contatos',
          actions: 'Ação',
        },
        toasts: {
          deleted: 'Lista excluída com sucesso!',
          deletedAll: 'Todas as listas foram excluídas com sucesso!',
        },
        buttons: {
          add: 'Adicionar',
          deleteAll: 'Deletar Todos',
        },
        confirmationModal: {
          deleteTitle: 'Deletar',
          deleteAllTitle: 'Deletar Todos',
          deleteMessage: 'Tem certeza que deseja deletar esta lista?',
          deleteAllMessage: 'Tem certeza que deseja deletar todas as listas?',
        },
      },
      messagesAPI: {
        title: 'API',
        labels: {
          doc: 'Documentação para envio de mensagens',
          method: 'Métodos de Envio',
          textMessage: 'Mensagem de Texto',
          mediaMessage: 'Mensagem de Mídia',
          instructions: 'Instruções',
          observations: 'Observações importantes',
          before1:
            'Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens.',
          before2:
            "Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
          numberDescription:
            'O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:',
          countryCode: 'Código do País',
          number: 'Número',
          textMessage2: '1. Mensagens de Texto',
          textMessageInstructions:
            'Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:',
          method2: 'Método',
          e: 'e',
          tests: 'Teste de Envio',
          mediaMessage2: '2. Mensagens de Mídia',
        },
        textMessage: {
          number: 'Número',
          body: 'Mensagem',
          token: 'Token cadastrado',
        },
        mediaMessage: {
          number: 'Número',
          body: 'Nome do arquivo',
          media: 'Arquivo',
          token: 'Token cadastrado',
        },
        toasts: {
          unauthorized:
            'Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.',
          success: 'Mensagem enviada com sucesso!',
        },
        buttons: {
          send: 'Enviar',
        },
      },
      notifications: {
        noTickets: 'Nenhuma notificação.',
      },
      quickMessages: {
        title: 'Respostas Rápidas',
        searchPlaceholder: 'Pesquisar...',
        noAttachment: 'Sem anexo',
        confirmationModal: {
          deleteTitle: 'Exclusão',
          deleteMessage: 'Esta ação é irreversível! Deseja prosseguir?',
        },
        buttons: {
          add: 'Adicionar',
          attach: 'Anexar Arquivo',
          cancel: 'Cancelar',
          edit: 'Editar',
          addAria: 'Adicionar resposta rápida',
          cancelAria: 'Cancelar operação',
        },
        toasts: {
          success: 'Atalho adicionado com sucesso!',
          deleted: 'Atalho removido com sucesso!',
        },
        dialog: {
          title: 'Mensagem Rápida',
          shortcode: 'Atalho',
          message: 'Resposta',
          save: 'Salvar',
          cancel: 'Cancelar',
          geral: 'Permitir editar',
          add: 'Adicionar',
          edit: 'Editar',
          visao: 'Permitir visão',
        },
        table: {
          shortcode: 'Atalho',
          message: 'Mensagem',
          actions: 'Ações',
          mediaName: 'Nome do Arquivo',
          status: 'Status',
        },
      },
      messageVariablesPicker: {
        label: 'Variavéis disponíveis',
        vars: {
          contactFirstName: 'Primeiro Nome',
          contactName: 'Nome',
          greeting: 'Saudação',
          protocolNumber: 'Protocolo',
          date: 'Data',
          hour: 'Hora',
        },
      },
      contactLists: {
        title: 'Listas de Contatos',
        table: {
          name: 'Nome',
          contacts: 'Contatos',
          actions: 'Ações',
        },
        buttons: {
          add: 'Nova Lista',
        },
        dialog: {
          name: 'Nome',
          nameShort: 'Nome curto',
          nameLong: 'Nome longo',
          nameRequired: 'Nome é obrigatório',
          company: 'Empresa',
          okEdit: 'Editar',
          okAdd: 'Adicionar',
          add: 'Adicionar',
          edit: 'Editar',
          cancel: 'Cancelar',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        toasts: {
          deleted: 'Registro excluído',
          success: 'Operação realizada com sucesso',
        },
      },
      contactListItems: {
        title: 'Contatos',
        searchPlaceholder: 'Pesquisa',
        buttons: {
          add: 'Novo',
          lists: 'Listas',
          import: 'Importar',
        },
        download: 'Clique aqui para baixar planilha exemplo.',
        dialog: {
          name: 'Nome',
          nameShort: 'Nome curto',
          nameLong: 'Nome longo',
          nameRequired: 'Nome é obrigatório',
          number: 'Número',
          numberShort: 'Número curto',
          numberLong: 'Número longo',
          whatsapp: 'Whatsapp',
          email: 'E-mail',
          emailInvalid: 'E-mail inválido',
          okEdit: 'Editar',
          okAdd: 'Adicionar',
          add: 'Adicionar',
          edit: 'Editar',
          cancel: 'Cancelar',
        },
        table: {
          name: 'Nome',
          number: 'Número',
          whatsapp: 'Whatsapp',
          email: 'E-mail',
          actions: 'Ações',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
          importMessage: 'Deseja importar os contatos desta planilha? ',
          importTitlte: 'Importar',
        },
        toasts: {
          deleted: 'Registro excluído',
        },
      },
      campaigns: {
        title: 'Campanhas',
        searchPlaceholder: 'Pesquisa',
        report: {
          title: 'Relatório de',
          title2: 'Campanha',
          of: 'de',
          validContacts: 'Contatos válidos',
          delivered: 'Entregues',
          connection: 'Conexão',
          contactList: 'Lista de Contatos',
          schedule: 'Agendamento',
          conclusion: 'Conclusão',
        },
        config: {
          interval: 'Intervalos',
          randomInterval: 'Intervalo Randômico de Disparo',
          biggerInterval: 'Intervalo Maior Após',
          greaterInterval: 'Intervalo de Disparo Maior',
          noInterval: 'Sem Intervalo',
          second: 'segundo',
          seconds: 'segundos',
          notDefined: 'Não definido',
          addVariable: 'Adicionar Variável',
          save: 'Salvar Configurações',
          shortcut: 'Atalho',
          content: 'Conteúdo',
          close: 'Fechar',
          add: 'Adicionar',
        },
        buttons: {
          add: 'Nova Campanha',
          contactLists: 'Listas de Contatos',
        },
        status: {
          inactive: 'Inativa',
          programmed: 'Programada',
          inProgress: 'Em andamento',
          canceled: 'Cancelada',
          finished: 'Finalizada',
        },
        table: {
          name: 'Nome',
          whatsapp: 'Conexão',
          contactList: 'Lista de Contatos',
          status: 'Status',
          scheduledAt: 'Agendamento',
          completedAt: 'Concluída',
          confirmation: 'Confirmação',
          actions: 'Ações',
          notDefined: 'Não definida',
          notDefined2: 'Não definido',
          notScheduled: 'Sem agendamento',
          notConcluded: 'Não concluída',
          stopCampaign: 'Parar Campanha',
        },
        dialog: {
          new: 'Nova Campanha',
          update: 'Editar Campanha',
          readonly: 'Apenas Visualização',
          form: {
            name: 'Nome',
            nameShort: 'Nome curto',
            nameLong: 'Nome longo',
            helper:
              'Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalziadas.',
            nameRequired: 'Nome é obrigatório',
            message1: 'Mensagem 1',
            message2: 'Mensagem 2',
            message3: 'Mensagem 3',
            message4: 'Mensagem 4',
            message5: 'Mensagem 5',
            messagePlaceholder: 'Conteúdo da mensagem',
            whatsapp: 'Conexão',
            status: 'Status',
            scheduledAt: 'Agendamento',
            confirmation: 'Confirmação',
            contactList: 'Lista de Contato',
            tagList: 'Lista de Tags',
            fileList: 'Lista de Arquivos',
          },
          buttons: {
            add: 'Adicionar',
            edit: 'Atualizar',
            okadd: 'Ok',
            cancel: 'Cancelar Disparos',
            restart: 'Reiniciar Disparos',
            close: 'Fechar',
            attach: 'Anexar Arquivo',
          },
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        toasts: {
          configSaved: 'Configurações salvas',
          success: 'Operação realizada com sucesso',
          cancel: 'Campanha cancelada',
          restart: 'Campanha reiniciada',
          deleted: 'Registro excluído',
        },
      },
      subscription: {
        title: 'Assinatura',
        testPeriod: 'Período de Teste',
        remainingTest: 'Seu período de teste termina em',
        remainingTest2: 'dias!',
        chargeEmail: 'E-mail de cobrança',
        signNow: 'Assinar agora!',
      },
      announcements: {
        active: 'Ativo',
        inactive: 'Inativo',
        title: 'Informativos',
        searchPlaceholder: 'Pesquisa',
        high: 'Alta',
        medium: 'Média',
        low: 'Baixa',
        buttons: {
          add: 'Novo Informativo',
          contactLists: 'Listas de Informativos',
        },
        table: {
          priority: 'Prioridade',
          title: 'Title',
          text: 'Texto',
          mediaName: 'Arquivo',
          status: 'Status',
          actions: 'Ações',
        },
        dialog: {
          edit: 'Edição de Informativo',
          add: 'Novo Informativo',
          update: 'Editar Informativo',
          readonly: 'Apenas Visualização',
          form: {
            priority: 'Prioridade',
            required: 'Campo obrigatório',
            title: 'Title',
            text: 'Texto',
            mediaPath: 'Arquivo',
            status: 'Status',
          },
          buttons: {
            add: 'Adicionar',
            edit: 'Atualizar',
            okadd: 'Ok',
            cancel: 'Cancelar',
            close: 'Fechar',
            attach: 'Anexar Arquivo',
          },
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        toasts: {
          success: 'Operação realizada com sucesso',
          deleted: 'Registro excluído',
          info: 'Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.',
        },
      },
      campaignsConfig: {
        title: 'Configurações de Campanhas',
      },
      queues: {
        title: 'Pipelines',
        table: {
          id: 'ID',
          name: 'Nome',
          color: 'Cor',
          greeting: 'Mensagem de saudação',
          actions: 'Ações',
          orderQueue: 'Ordenação da pipeline (bot)',
        },
        buttons: {
          add: 'Adicionar pipeline',
        },
        toasts: {
          success: 'Pipeline deletada com sucesso.',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            'Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa pipeline continuarão existindo, mas não terão mais nenhuma pipeline atribuída.',
        },
      },
      queueSelect: {
        inputLabel: 'Pipelines',
      },
      users: {
        title: 'Usuários',
        table: {
          id: 'ID',
          name: 'Nome',
          email: 'Email',
          profile: 'Perfil',
          actions: 'Ações',
        },
        buttons: {
          add: 'Adicionar usuário',
        },
        toasts: {
          deleted: 'Usuário excluído com sucesso.',
        },
        confirmationModal: {
          deleteTitle: 'Excluir',
          deleteMessage:
            'Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a pipeline.',
        },
      },
      todolist: {
        input: 'Nova tarefa',
        buttons: {
          add: 'Adicionar',
          save: 'Salvar',
        },
      },
      helps: {
        title: 'Central de Ajuda',
      },
      schedules: {
        title: 'Agendamentos',
        confirmationModal: {
          deleteTitle: 'Você tem certeza que quer excluir este Agendamento?',
          deleteMessage: 'Esta ação não pode ser revertida.',
        },
        table: {
          contact: 'Contato',
          body: 'Mensagem',
          sendAt: 'Data de Agendamento',
          sentAt: 'Data de Envio',
          status: 'Status',
          actions: 'Ações',
        },
        messages: {
          date: 'Data',
          time: 'Hora',
          event: 'Evento',
          allDay: 'Dia Todo',
          week: 'Semana',
          work_week: 'Agendamentos',
          day: 'Dia',
          month: 'Mês',
          previous: 'Anterior',
          next: 'Próximo',
          yesterday: 'Ontem',
          tomorrow: 'Amanhã',
          today: 'Hoje',
          agenda: 'Agenda',
          noEventsInRange: 'Não há agendamentos no período.',
          showMore: 'mais',
        },
        buttons: {
          add: 'Novo Agendamento',
        },
        toasts: {
          deleted: 'Agendamento excluído com sucesso.',
        },
      },
      tags: {
        title: 'Tags',
        confirmationModal: {
          deleteTitle: 'Você tem certeza que quer excluir esta Tag?',
          deleteMessage: 'Esta ação não pode ser revertida.',
          deleteAllMessage: 'Tem certeza que deseja deletar todas as Tags?',
          deleteAllTitle: 'Deletar Todos',
        },
        table: {
          name: 'Nome',
          color: 'Cor',
          tickets: 'Registros Tagdos',
          actions: 'Ações',
        },
        buttons: {
          add: 'Nova Tag',
          deleteAll: 'Deletar Todas',
        },
        toasts: {
          deletedAll: 'Todas Tags excluídas com sucesso!',
          deleted: 'Tag excluído com sucesso.',
        },
      },
      settings: {
        schedulesUpdated: 'Horários atualizados com sucesso.',
        success: 'Configurações salvas com sucesso.',
        title: 'Configurações',
        tabs: {
          options: 'Opções',
          schedules: 'Horários',
          companies: 'Empresas',
          plans: 'Planos',
          helps: 'Ajuda',
        },
        options: {
          toasts: {
            success: 'Operação atualizada com sucesso.',
            error: 'Erro ao atualizar configuração.',
          },
          fields: {
            ratings: {
              title: 'Avaliações',
              disabled: 'Desabilitadas',
              enabled: 'Habilitadas',
            },
            expedientManager: {
              title: 'Gerenciamento de Expediente',
              queue: 'Pipeline',
              company: 'Empresa',
            },
            ignoreMessages: {
              title: 'Ignorar Mensagens de Grupos',
            },
            acceptCall: {
              title: 'Aceitar Chamada',
              disabled: 'Não aceitar',
              enabled: 'Aceitar',
            },
            chatbotType: {
              title: 'Tipo Chatbot',
              text: 'Texto',
            },
            sendGreetingAccepted: {
              title: 'Enviar saudação ao aceitar o ticket',
            },
            sendMsgTransfTicket: {
              title: 'Enviar mensagem de transferencia de Pipeline/agente',
            },
            sendGreetingMessageOneQueues: {
              title: 'Enviar saudação quando houver somente 1 pipeline',
            },
            idleTimeLimit: {
              title: 'Tempo Máximo de Ociosidade',
              description:
                'Define o tempo máximo em minutos para considerar um ticket como ocioso',
            },
            disabled: 'Desabilitado',
            active: 'Ativo',
            enabled: 'Habilitado',
          },
          updating: 'Atualizando...',
          tabs: {
            integrations: 'INTEGRAÇÕES',
          },
        },
        helps: {
          toasts: {
            errorList: 'Não foi possível carregar a lista de registros',
            errorOperation: 'Não foi possível realizar a operação',
            error:
              'Não foi possível realizar a operação. Verifique se já existe uma helpo com o mesmo nome ou se os campos foram preenchidos corretamente',
            success: 'Operação realizada com sucesso!',
          },
          buttons: {
            clean: 'Limpar',
            delete: 'Excluir',
            save: 'Salvar',
          },
          grid: {
            title: 'Título',
            description: 'Descrição',
            video: 'Vídeo',
          },
          confirmModal: {
            title: 'Exclusão de Registro',
            confirm: 'Deseja realmente excluir esse registro?',
          },
        },
        company: {
          toasts: {
            errorList: 'Não foi possível carregar a lista de registros',
            errorOperation: 'Não foi possível realizar a operação',
            error:
              'Não foi possível realizar a operação. Verifique se já existe uma empresa com o mesmo nome ou se os campos foram preenchidos corretamente',
            success: 'Operação realizada com sucesso!',
          },
          confirmModal: {
            title: 'Exclusão de Registro',
            confirm: 'Deseja realmente excluir esse registro?',
          },
          form: {
            name: 'Nome',
            email: 'E-mail',
            phone: 'Telefone',
            plan: 'Plano',
            status: 'Status',
            yes: 'Sim',
            no: 'Não',
            campanhas: 'Campanhas',
            enabled: 'Habilitadas',
            disabled: 'Desabilitadas',
            dueDate: 'Data de vencimento',
            recurrence: 'Recorrência',
            monthly: 'Mensal',
            expire: 'Vencimento',
            createdAt: 'Criada Em',
          },
          buttons: {
            clear: 'Limpar',
            delete: 'Excluir',
            expire: '+ Vencimento',
            user: 'Usuário',
            save: 'Salvar',
          },
        },
        schedules: {
          form: {
            weekday: 'Dia da Semana',
            initialHour: 'Hora Inicial',
            finalHour: 'Hora Final',
            save: 'Salvar',
          },
        },
        settings: {
          userCreation: {
            name: 'Criação de usuário',
            options: {
              enabled: 'Ativado',
              disabled: 'Desativado',
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: 'Atribuído à:',
          buttons: {
            return: 'Retornar',
            resolve: 'Resolver',
            reopen: 'Reabrir',
            accept: 'Aceitar',
            download: 'Baixar',
          },
        },
        lostCall: 'Chamada de voz/vídeo perdida às',
        deletedMessage: 'Essa mensagem foi apagada pelo contato',
        edited: 'Editada',
        saudation: 'Diga olá para seu novo contato!',
      },
      messagesInput: {
        placeholderOpen: 'Digite uma mensagem',
        placeholderClosed:
          'Reabra ou aceite esse ticket para enviar uma mensagem.',
        signMessage: 'Assinar',
      },
      contactDrawer: {
        header: 'Dados do contato',
        buttons: {
          edit: 'Editar contato',
        },
        extraInfo: 'Outras informações',
        attendanceHistory: {
          title: 'Histórico de atendimentos',
          selectLabel: 'Selecione o atendimento',
          attendanceOption: 'Atendimento {number} - {status}',
          statusClosed: 'Concluído',
          statusOpen: 'Em andamento',
          statusLost: 'Perdido',
          noAttendances: 'Nenhum atendimento registrado para este contato.',
        },
      },
      fileModal: {
        title: {
          add: 'Adicionar lista de arquivos',
          edit: 'Editar lista de arquivos',
        },
        buttons: {
          okAdd: 'Salvar',
          okEdit: 'Editar',
          cancel: 'Cancelar',
          fileOptions: 'Adicionar arquivo',
        },
        form: {
          name: 'Nome da lista de arquivos',
          message: 'Detalhes da lista',
          fileOptions: 'Lista de arquivos',
          extraName: 'Mensagem para enviar com arquivo',
          extraValue: 'Valor da opção',
        },
        formErrors: {
          name: {
            required: 'Nome é obrigatório',
            short: 'Nome muito curto',
          },
          message: {
            required: 'Mensagem é obrigatória',
          },
        },
        success: 'Lista de arquivos salva com sucesso!',
      },
      ticketOptionsMenu: {
        attachment: 'Anexos',
        schedule: 'Agendamento',
        cart: 'Carrinho',
        scheduleMessage: 'Agendamento de mensagem',
        delete: 'Deletar',
        transfer: 'Transferir',
        registerAppointment: 'Observações do Contato',
        stageActivities: 'Atividades do Estágio',
        dispatches: 'Disparos',
        appointmentsModal: {
          title: 'Observações do Contato',
          textarea: 'Observação',
          placeholder: 'Insira aqui a informação que deseja registrar',
        },
        stageActivitiesModal: {
          title: 'Atividades do Estágio',
          progress: 'Progresso',
          close: 'Fechar',
          noActivities: 'Nenhuma atividade configurada para este estágio.',
        },
        confirmationModal: {
          title: 'Deletar o ticket',
          titleFrom: 'do contato ',
          message:
            'Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.',
        },
        buttons: {
          delete: 'Excluir',
          cancel: 'Cancelar',
        },
      },
      confirmationModal: {
        buttons: {
          confirm: 'Ok',
          cancel: 'Cancelar',
        },
      },
      messageOptionsMenu: {
        delete: 'Deletar',
        reply: 'Responder',
        confirmationModal: {
          title: 'Apagar mensagem?',
          message: 'Esta ação não pode ser revertida.',
        },
      },
      backendErrors: {
        ERR_INTERNAL_SERVER_ERROR:
          'Ocorreu um erro inesperado. Por favor, tente novamente mais tarde',
        ERR_NO_OTHER_WHATSAPP: 'Deve haver pelo menos um WhatsApp padrão.',
        ERR_NO_DEF_WAPP_FOUND:
          'Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.',
        ERR_WAPP_NOT_INITIALIZED:
          'Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.',
        ERR_WAPP_CHECK_CONTACT:
          'Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões',
        ERR_WAPP_INVALID_CONTACT: 'Este não é um número de Whatsapp válido.',
        ERR_WAPP_DOWNLOAD_MEDIA:
          'Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.',
        ERR_INVALID_CREDENTIALS:
          'Erro de autenticação. Por favor, tente novamente.',
        ERR_USER_DONT_EXISTS:
          'Usuário não encontrado. Verifique o e-mail informado.',
        ERR_SENDING_WAPP_MSG:
          'Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.',
        ERR_DELETE_WAPP_MSG: 'Não foi possível excluir a mensagem do WhatsApp.',
        ERR_OTHER_OPEN_TICKET: 'Já existe um tíquete aberto para este contato.',
        ERR_SESSION_EXPIRED: 'Sessão expirada. Por favor entre.',
        ERR_USER_CREATION_DISABLED:
          'A criação do usuário foi desabilitada pelo administrador.',
        ERR_NO_PERMISSION: 'Você não tem permissão para acessar este recurso.',
        ERR_DUPLICATED_CONTACT: 'Já existe um contato com este número.',
        ERR_NO_SETTING_FOUND: 'Nenhuma configuração encontrada com este ID.',
        ERR_NO_CONTACT_FOUND: 'Nenhum contato encontrado com este ID.',
        ERR_NO_TICKET_FOUND: 'Nenhum tíquete encontrado com este ID.',
        ERR_NO_USER_FOUND: 'Nenhum usuário encontrado com este ID.',
        ERR_NO_WAPP_FOUND: 'Nenhum WhatsApp encontrado com este ID.',
        ERR_CREATING_MESSAGE: 'Erro ao criar mensagem no banco de dados.',
        ERR_CREATING_TICKET: 'Erro ao criar tíquete no banco de dados.',
        ERR_FETCH_WAPP_MSG:
          'Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.',
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          'Esta cor já está em uso, escolha outra.',
        ERR_WAPP_GREETING_REQUIRED:
          'A mensagem de saudação é obrigatório quando há mais de uma pipeline.',
      },
      fileLinksModal: {
        title: 'Gerenciar Links de Arquivos',
        addForm: {
          title: 'Adicionar Novo Link de Arquivo',
        },
        form: {
          fileName: 'Nome do Arquivo',
          fileUrl: 'Link do Arquivo',
          fileNamePlaceholder: 'Ex: Contrato de Prestação de Serviços',
          fileUrlPlaceholder:
            'Ex: drive.google.com/file/d/... ou /caminho/arquivo.pdf',
        },
        list: {
          title: 'Links de Arquivos ({{count}})',
        },
        buttons: {
          addLink: 'Adicionar Link',
          save: 'Salvar',
          cancel: 'Cancelar',
          edit: 'Editar',
          delete: 'Remover',
          openLink: 'Abrir link externo',
          close: 'Fechar',
        },
        emptyState: {
          title: 'Nenhum link de arquivo adicionado',
          subtitle: 'Use o formulário acima para adicionar o primeiro link',
        },
        confirmationModal: {
          title: 'Confirmar Exclusão',
          message: 'Tem certeza que deseja remover o link "{{fileName}}"?',
          url: 'URL',
          warning: 'Esta ação não pode ser desfeita.',
        },
        validation: {
          fileNameTooShort: 'Nome muito curto',
          fileNameRequired: 'Nome do arquivo é obrigatório',
          fileUrlRequired: 'Link do arquivo é obrigatório',
        },
        toasts: {
          linkAdded: 'Link do arquivo adicionado com sucesso!',
          linkUpdated: 'Link do arquivo atualizado!',
          linkDeleted: 'Link do arquivo removido com sucesso!',
          fileNameTooShort: 'Nome do arquivo deve ter pelo menos 2 caracteres',
          fileUrlRequired: 'URL do arquivo é obrigatória',
        },
      },
      products: {
        title: 'Produtos/Serviços',
        searchPlaceholder: 'Buscar produtos...',
        toasts: {
          deleted: 'Produto excluído com sucesso!',
          created: 'Produto criado com sucesso!',
          updated: 'Produto atualizado com sucesso!',
        },
        buttons: {
          add: 'Adicionar Produto',
        },
        table: {
          name: 'Nome',
          type: 'Tipo',
          price: 'Preço',
          description: 'Descrição',
          doctorEmail: 'Email agendamento',
          status: 'Status',
          actions: 'Ações',
        },
        confirmationModal: {
          deleteTitle: 'Excluir produto',
          deleteMessage: 'Tem certeza? Esta ação não pode ser desfeita.',
        },
      },
      productModal: {
        title: {
          add: 'Adicionar Produto/Serviço',
          edit: 'Editar Produto/Serviço',
        },
        form: {
          name: 'Nome',
          type: 'Tipo',
          price: 'Preço',
          description: 'Descrição',
          email: 'Email de agendamento',
          active: 'Ativo',
          amount: 'Quantidade',
          schedule: 'Permitir agendamento?',
        },
        buttons: {
          okAdd: 'Adicionar',
          okEdit: 'Salvar',
          cancel: 'Cancelar',
        },
      },
      orderModal: {
        title: 'Processar Venda - Produtos/Serviços',
        categories: {
          all: 'Todos',
          products: 'Produtos',
          services: 'Serviços',
        },
        search: {
          label: 'Buscar produtos/serviços',
          placeholder: 'Digite o nome do produto ou serviço...',
        },
        availableItems: {
          title: 'Produtos e Serviços Disponíveis',
        },
        itemTypes: {
          product: 'Produto',
          service: 'Serviço',
        },
        stock: 'Estoque: {{stock}} unidades',
        duration: 'Duração: {{duration}}',
        noItemsFound: 'Nenhum item encontrado',
        orderSummary: {
          title: 'Itens da Venda ({{count}})',
          subtotal: 'Subtotal',
          total: 'Total',
          empty: 'Nenhum item adicionado',
        },
        buttons: {
          add: 'Adicionar',
          cancel: 'Cancelar',
          confirm: 'Processar Venda',
        },
        toasts: {
          itemAdded: '{{itemName}} adicionado ao pedido',
          orderCreated: 'Venda processada com sucesso!',
        },
        scheduleChoice: {
          removeTitle: 'Este item possui agendamento(s). O que deseja fazer?',
          reduceTitle: 'Escolha qual(is) agendamento(s) deseja cancelar',
          beforeProcessTitle:
            'Antes de processar a venda: selecione qual(is) agendamento(s) cancelar',
          selectAll: 'Selecionar todos (cancelar todos)',
          selectOneRequired:
            'Selecione o(s) agendamento(s) indicado(s) para cancelar antes de processar a venda.',
          cancelled: 'Agendamento(s) cancelado(s).',
        },
      },
      languages: {
        pt: 'Português (BR)',
        en: 'English',
        es: 'Español',
        tr: 'Türkçe',
      },
    },
  },
};

export { messages };
